import { notification } from 'antd';
import { call, debounce, put } from 'redux-saga/effects';

import { DEFAULT_DEBOUNCE_DELAY } from '#constants';
import ProviderService from '#services/ProviderService';

import { getProviders, getProvidersError, setProviders } from './';

function* getProvidersList({ payload }) {
  try {
    const providers = yield call(ProviderService.getList, payload);
    yield put(setProviders(providers));
  } catch (error) {
    notification.error({ message: error?.response?.data?.error?.message });
    yield put(setProviders({ count: 0, result: [] }));
    yield put(getProvidersError());
  }
}

function* ProviderSaga() {
  yield debounce(DEFAULT_DEBOUNCE_DELAY, getProviders.type, getProvidersList);
}

export default ProviderSaga;
